import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { JSX } from "react";

import { CampaignsPage } from "@/features/promotion";

function CampaignRoute(): JSX.Element {
  const navigate = useNavigate();
  // Opening a campaign drills into its promotions, pre-filtered by campaign_id.
  return (
    <CampaignsPage
      onOpenCampaign={(campaign) =>
        void navigate({ to: "/promotion", search: { campaign_id: campaign.id } })
      }
    />
  );
}

export const Route = createFileRoute("/_authenticated/campaign")({
  component: CampaignRoute,
});
